import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * The ONLY class-composition helper in this application.
 *
 * Every component composes its className through this function and through
 * nothing else. Two libraries, doing two different jobs:
 *
 *   - `clsx` flattens the conditional forms — arrays, objects, falsy values —
 *     which is how a component says "this class, unless that prop is set".
 *   - `tailwind-merge` resolves CONFLICTS, so a caller's override actually
 *     wins. Without it, `cn('p-2', 'p-4')` emits both and the winner is
 *     decided by stylesheet order rather than by the call site.
 *
 * That second point is the whole reason this function is centralised. A
 * component that hand-rolls class concatenation silently reintroduces the
 * conflict problem, and the override then works locally until someone changes
 * the order of a rule.
 *
 * Ordering matters: clsx must run first so that only real class strings reach
 * twMerge. Merging unresolved conditionals would produce nonsense.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
